import { AdminNavItem, AdminNavItemWithTo } from '../../types';
import { AdminDelegate } from '../delegates';
import ApplicationRecord from './ApplicationRecord';

const registry: typeof ApplicationRecord[] = [];
const map: Hash<number> = {};

export function registerModel(model: typeof ApplicationRecord) {
  if (Object.isFrozen(registry)) {
    throw new Error('The registry is frozen');
  }
  if (registry.indexOf(model) !== -1) {
    if (process.env.NODE_ENV === 'development') {
      window.console.warn(`The model "${model}" is already registered!`);
    }
    return;
  }
  if (!model.jsonapiType) {
    if (process.env.NODE_ENV === 'development') {
      window.console.warn(`The model "${model}" does not have a jsonapiType!`);
    }
    return;
  }
  map[model.jsonapiType] = registry.length;
  registry.push(model);
}

export function getFrozenRegistry() {
  if (!Object.isFrozen(registry)) {
    Object.freeze(registry);
  }
  return registry;
}

export function lookupModel<T = typeof ApplicationRecord>(jsonapiType: string) {
  const index = map[jsonapiType];
  if (index === undefined) {
    return undefined;
  }
  return registry[index] as unknown as T;
}

export function getAdminNavItems(): AdminNavItem[] {
  const registry = getFrozenRegistry();
  const items: AdminNavItem[] = [];
  for (let n = 0; n < registry.length; n += 1) {
    const klass = registry[n];
    const { jsonapiType, adminDelegate } = klass;
    if (!jsonapiType || !adminDelegate) {
      continue;
    }
    const {
      canList,
      navTitle,
      navIcon: icon,
      navOrder: order,
      pluralName,
      navLink,
    } = klass.adminDelegate as AdminDelegate;
    if (!canList) {
      continue;
    }
    const text = navTitle || pluralName;
    if (!text) {
      continue;
    }
    const item: AdminNavItemWithTo = {
      key: jsonapiType,
      order,
      icon,
      text,
      to: navLink(jsonapiType),
    };
    items.push(item);
  }
  return items;
}
